import type {
  CarrierCode,
  CarrierCodeApi,
  CarrierCodeFilters,
  CarrierCodeFiltersUpdateApi,
  CarrierCodes,
  CarrierCodesApi,
} from '../../models';
import { inlineSearch, paginate } from '../normalize';

const PACKCODE_TYPE = 'PACKCODE';

export const normalizeCarrierCode = (carrierCode: CarrierCodeApi): CarrierCode => ({
  ...carrierCode,
  label: carrierCode.codeDesc,
});

export const normalizeCarrierCodes = (response: CarrierCodesApi): CarrierCodes => {
  const list = (response.items ?? [])
    .filter((carrierCode) => carrierCode.codeType?.toUpperCase() === PACKCODE_TYPE)
    .sort((a, b) => a.codeDesc.localeCompare(b.codeDesc))
    .map(normalizeCarrierCode);
  return {
    list,
    map: list.reduce(
      (acc, carrierCode) => {
        acc[String(carrierCode.id)] = carrierCode;
        return acc;
      },
      {} as CarrierCodes['map'],
    ),
  };
};

export const normalizeCarrierCodeFilters = (filters: Partial<CarrierCodeFilters>): CarrierCodeFiltersUpdateApi => {
  const { search, carrierKey, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch(otherFilters),
    ...paginate(otherFilters),
    codeType: PACKCODE_TYPE,
    ...(carrierKey !== undefined ? { carrierKey } : {}),
    Sorting: 'codeDesc asc',
  };
};
